const useSecureContext = () => {
  return window.isSecureContext;
};

export default useSecureContext;
